export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

export const RECEIVE_USER = 'RECEIVE_USER';
export const SET_TOKEN = 'SET_TOKEN';

export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';

export const RECEIVE_STATES = 'RECEIVE_STATES';

export const SHOW_CROPPER = 'SHOW_CROPPER';
export const HIDE_CROPPER = 'HIDE_CROPPER';
export const RECEIVE_CROPPER_IMAGE = 'RECEIVE_CROPPER_IMAGE';
export const CROPPER_ZOOM = 'CROPPER_ZOOM';

export const SUBSCRIPTION_UNPAID = 'unpaid';
export const SUBSCRIPTION_PAST_DUE = 'past_due';
export const SUBSCRIPTION_ACTIVE = 'active';
export const SUBSCRIPTION_CANCELED = 'canceled';



// WEBPACK FOOTER //
// ./src/constants/index.js